"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./mandatoryClaimBanner.scss");
const elementKit_1 = require("../../../elementKit");
const mandatoryClaimBannerTranslations_json_1 = __importDefault(require("./mandatoryClaimBannerTranslations/mandatoryClaimBannerTranslations.json"));
const claimBannerTranslations_json_1 = __importDefault(require("../claimBanner/claimBannerTranslations/claimBannerTranslations.json"));
const master_1 = require("../../../constants/master");
const SignupOtpPopup_1 = __importDefault(require("../../popups/signupOtpPopup/SignupOtpPopup"));
const claimingFlowUtils_1 = require("../../../services/utils/claimingFlowUtils");
const services_1 = require("../../../services");
function MandatoryClaimBanner(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    props.addTranslation(mandatoryClaimBannerTranslations_json_1.default);
    props.addTranslation(claimBannerTranslations_json_1.default);
    const [claimAvailable, setClaimAvailable] = react_1.default.useState(props.userMeta.userId === ((_a = props.velocityOffer) === null || _a === void 0 ? void 0 : _a.userId));
    const [claimSignupOtpOpen, setClaimSignupOtpOpen] = react_1.default.useState(false);
    const optimizedMixpanel = props.mixpanel
        ? new services_1.OptimizedMixPanel(props.mixpanel)
        : null;
    (0, react_1.useEffect)(() => {
        var _a;
        setClaimAvailable(props.userMeta.userId === ((_a = props.velocityOffer) === null || _a === void 0 ? void 0 : _a.userId));
    }, [props.userMeta.userId, (_b = props.velocityOffer) === null || _b === void 0 ? void 0 : _b.userId]);
    const getButtonCss = ((_c = props.velocityOffer) === null || _c === void 0 ? void 0 : _c.isClaimingMandatory) === true
        ? { border: "2px solid #FFFFFF", backgroundColor: "#FF3B3B" }
        : undefined;
    function getButtonText() {
        var _a, _b;
        if (((_a = props.velocityOffer) === null || _a === void 0 ? void 0 : _a.isClaimingMandatory) === true ||
            props.userMeta.userId === ((_b = props.velocityOffer) === null || _b === void 0 ? void 0 : _b.userId)) {
            return "claimCredential";
        }
        if (!props.userMeta.logged) {
            return "login";
        }
        return "switchAccount";
    }
    function sendClaimingEventToMixpanel() {
        var _a, _b;
        optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track("Mandatory-Optional Claiming Action", {
            claimingType: ((_a = props.velocityOffer) === null || _a === void 0 ? void 0 : _a.isClaimingMandatory)
                ? "mandatory"
                : "optional",
            credentialUserId: (_b = props.velocityOffer) === null || _b === void 0 ? void 0 : _b.userId,
            credentialNo: props.credential_no,
        });
    }
    return (react_1.default.createElement("div", { id: "mandatory-claim-banner", className: `flex-${props.isMobile ? "column" : "row"} ai-c ${((_d = props.velocityOffer) === null || _d === void 0 ? void 0 : _d.isClaimingMandatory) === true
            ? "claim-available"
            : "claim-disabled"} ${props.isMobile ? "mobile" : ""}` },
        react_1.default.createElement("span", { className: "claim-cred-text" }, props
            .translate((0, claimingFlowUtils_1.getClaimingDescTextKey)(props.userMeta, props.velocityOffer, props.userEmail))
            .toString()),
        react_1.default.createElement(elementKit_1.Basebutton, { size: "small", type: "secondary", loading: false, height: 35, primaryColor: ((_e = props.velocityOffer) === null || _e === void 0 ? void 0 : _e.isClaimingMandatory) === true
                ? "#FFFFFF"
                : (0, master_1.getMasterConfig)().primaryColor, styles: getButtonCss, onClickAction: () => {
                var _a, _b, _c;
                if (claimAvailable) {
                    sendClaimingEventToMixpanel();
                    props.historyPush({
                        pathname: "/" + ((_a = props.activeLanguage.code) !== null && _a !== void 0 ? _a : "en") + "/quick-claim",
                        search: "?type=offerId&value=" +
                            ((_b = props.velocityOffer) === null || _b === void 0 ? void 0 : _b.id) +
                            "&credNo=" +
                            ((_c = props.velocityOffer) === null || _c === void 0 ? void 0 : _c.credentialNo) +
                            "&orgName=" +
                            props.issuedBy,
                    });
                    return;
                }
                setClaimSignupOtpOpen(true);
            } },
            react_1.default.createElement("span", { className: "claim-btn-text" }, props.translate(getButtonText()).toString())),
        claimSignupOtpOpen && (react_1.default.createElement(SignupOtpPopup_1.default, Object.assign({}, props, { dialogOpen: claimSignupOtpOpen, handleClose: () => {
                setClaimSignupOtpOpen(false);
            }, popupDescriptionTranslationKey: "verifyItsYouDescTextClaim", shouldRedirectTo: ((_f = props.velocityOffer) === null || _f === void 0 ? void 0 : _f.isClaimingMandatory) != null
                ? "/" + ((_g = props.activeLanguage.code) !== null && _g !== void 0 ? _g : "en") + "/quick-claim"
                : window.location.pathname, actionType: "claiming", redirectSearch: ((_h = props.velocityOffer) === null || _h === void 0 ? void 0 : _h.isClaimingMandatory) != null
                ? "?type=offerId&value=" +
                    ((_j = props.velocityOffer) === null || _j === void 0 ? void 0 : _j.id) +
                    "&credNo=" +
                    ((_k = props.velocityOffer) === null || _k === void 0 ? void 0 : _k.credentialNo) +
                    "&orgName=" +
                    props.issuedBy
                : "", key: "signup-otp-popup" })))));
}
exports.default = MandatoryClaimBanner;
